import * as React from "react";
import { ClinicPageWrapper } from "../elements/clinicPageWrapper";
import {
  Route,
  Switch,
  useHistory,
  useParams,
  useRouteMatch,
} from "react-router";
import { FeedbackReport } from "./feedbackReport";
import { ReportsList } from "./reportsList";
import { Link, styled } from "@mui/material";
import { removeTrailingSlash } from "fe-common/routes/removeTrailingSlash";
import { useEffect } from "react";
import ClinicExchangesReport from "./clinicExchangesReport";

//region [[ Styles ]]
const BackLink = styled(Link)({
  fontSize: 14,
  marginLeft: "auto",
});
//endregion [[ Styles ]]

//region [[ Props ]]
type Report = {
  name: string;
  title: string;
  component: React.ReactNode;
};
export interface ClinicReportsProps {}

export const reports: Report[] = [
  {
    name: "feedback",
    title: "Dialogue Feedbacks Report",
    component: <FeedbackReport />,
  },
  {
    name: "exchanges",
    title: "Dialogue Exchanges Report",
    component: <ClinicExchangesReport />,
  },
];

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicReports = ({ ...props }: ClinicReportsProps) => {
  const { reportName }: { reportName: string } = useParams();
  let history = useHistory();
  const [selectedReport, setSelectedReport] = React.useState<Report>(null);

  useEffect(() => {
    setSelectedReport(reports.find((report) => report.name === reportName));
  }, [reportName]);

  return (
    <ClinicPageWrapper
      pageTitle={
        <>
          {selectedReport?.title || "Clinic Reports"}
          {selectedReport && (
            <BackLink onClick={() => history.push("./")}>Back</BackLink>
          )}
        </>
      }
    >
      <Switch>
        {reports.map((report) => (
          <Route key={report.name} path={`*/${report.name}`}>
            {report.component}
          </Route>
        ))}
        <Route exact path={"*/"}>
          <ReportsList />
        </Route>
      </Switch>
    </ClinicPageWrapper>
  );
};
